<template>
  <div v-if="newVersionAvailable" class="version-alert">
    🔄 New Version found <button @click="reloadPage">Reload</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentVersion: null,
      newVersionAvailable: false,
      pollingInterval: null,
    };
  },
  created() {
    if (process.env.NODE_ENV === "development") return;

    // อ่านค่าจาก meta tag
    const meta = document.querySelector('meta[name="app-version"]');
    this.currentVersion = meta?.content || null;

    this.checkVersion(); // เช็คตอนเริ่ม
    this.pollingInterval = setInterval(this.checkVersion, 180000); // เช็คทุก 3 นาที
  },
  beforeDestroy() {
    clearInterval(this.pollingInterval);
  },
  methods: {
    async checkVersion() {
      try {
        const res = await fetch("/version.json", { cache: "no-cache" });
        const data = await res.json();

        if (this.currentVersion && data.version !== this.currentVersion) {
          console.log("[version-checker] พบเวอร์ชันใหม่:", data.version);
          this.newVersionAvailable = true;
        }
      } catch (err) {
        console.error("[version-checker] เช็กเวอร์ชันล้มเหลว:", err);
      }
    },
    reloadPage() {
      window.location.reload(true); // รีโหลดแบบ force reload
    },
  },
};
</script>

<style scoped>
.version-alert {
  position: fixed;
  bottom: 10px;
  right: 10px;
  background: #fffae5;
  border: 1px solid #ffa500;
  padding: 10px 15px;
  border-radius: 8px;
  font-size: 14px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
}
.version-alert button {
  margin-left: 10px;
  background: #ffa500;
  border: none;
  color: white;
  padding: 5px 10px;
  border-radius: 6px;
  cursor: pointer;
}
.version-alert button:hover {
  background: #e09100;
}
</style>
